'use client';

import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Professional/Professional.module.scss';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';

interface ProfessionalCardProps {
  readonly logo: {
    readonly src: string;
    readonly alt: string;
    readonly width: number;
    readonly height: number;
  };
  readonly description: ReadonlyArray<string>;
}

export default function ProfessionalCard({ logo, description }: ProfessionalCardProps) {
  const dealType = useGetDealType();
  return (
    <div className={styles.professionalCard}>
      <div className={styles.logoContainer}>
        <Image src={logo.src} alt={logo.alt} width={logo.width} height={logo.height} />
      </div>
      <div className={styles.description}>
        {description.map((item) => (
          <div className={styles.descriptionItem} key={item}>
            <div className={styles.checkIcon}>
              <Image
                src={dealType === 'rent' ? '/cc/image/icon_check_green.svg' : '/cc/image/icon_check_blue.svg'}
                alt={'check icon'}
                fill
              />
            </div>
            <Text category="caption" variant="m1" color="var(--color-gray-700)" as="span">
              {item}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}
